import React, { useState } from "react";
import { useLanguage } from "../App";
import { Dialog, DialogContent } from "./ui/dialog";
import { X } from "lucide-react";

const Gallery = () => {
  const { language } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      url: "https://customer-assets.emergentagent.com/job_53c07cd7-1ab5-4cff-8752-32dcf9dc74c8/artifacts/vzwdz346_IMG_3881.jpeg",
      title: { en: "Kitesurf Setup", es: "Preparación de Kitesurf", de: "Kitesurf-Vorbereitung", fr: "Préparation Kitesurf" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_acc6b5c6-4c76-49ba-a1fd-498cb047a8ad/artifacts/2ssms2jc_IMG_4372.jpeg",
      title: { en: "Kitesurfing at White Dune", es: "Kitesurf en Duna Blanca", de: "Kitesurfen an der Weißen Düne", fr: "Kitesurf à la Dune Blanche" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_53c07cd7-1ab5-4cff-8752-32dcf9dc74c8/artifacts/cgm41z2b_IMG_3882.jpeg",
      title: { en: "Beach Training", es: "Entrenamiento en Playa", de: "Strand-Training", fr: "Entraînement Plage" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_acc6b5c6-4c76-49ba-a1fd-498cb047a8ad/artifacts/dgzv3lxd_IMG_4371.jpeg",
      title: { en: "Kite Setup with 4x4", es: "Preparación de Kite con 4x4", de: "Kite-Setup mit 4x4", fr: "Préparation Kite avec 4x4" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_53c07cd7-1ab5-4cff-8752-32dcf9dc74c8/artifacts/skxgzrv7_IMG_3877.jpeg",
      title: { en: "Desert Landscape", es: "Paisaje Desértico", de: "Wüstenlandschaft", fr: "Paysage Désertique" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_acc6b5c6-4c76-49ba-a1fd-498cb047a8ad/artifacts/56vnk8fu_IMG_3879.jpeg",
      title: { en: "Horseback Riding on Beach", es: "Paseo a Caballo en la Playa", de: "Reiten am Strand", fr: "Balade à Cheval sur la Plage" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_53c07cd7-1ab5-4cff-8752-32dcf9dc74c8/artifacts/rborzla5_IMG_3870.jpeg",
      title: { en: "Lagoon Views", es: "Vistas de la Laguna", de: "Lagunenansichten", fr: "Vues Lagune" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_acc6b5c6-4c76-49ba-a1fd-498cb047a8ad/artifacts/5a1g73ru_IMG_3869.jpeg",
      title: { en: "Kite Lesson with Instructor", es: "Clase de Kite con Instructor", de: "Kite-Unterricht mit Instruktor", fr: "Cours de Kite avec Instructeur" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_53c07cd7-1ab5-4cff-8752-32dcf9dc74c8/artifacts/v771mpyr_IMG_3866.jpeg",
      title: { en: "Kitesurf Action", es: "Acción de Kitesurf", de: "Kitesurf-Action", fr: "Action Kitesurf" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_53c07cd7-1ab5-4cff-8752-32dcf9dc74c8/artifacts/tbuvuvvy_IMG_3883.jpeg",
      title: { en: "Perfect Conditions", es: "Condiciones Perfectas", de: "Perfekte Bedingungen", fr: "Conditions Parfaites" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_53c07cd7-1ab5-4cff-8752-32dcf9dc74c8/artifacts/wpd99f5c_IMG_3880.jpeg",
      title: { en: "Lagoon Experience", es: "Experiencia en Laguna", de: "Lagunen-Erlebnis", fr: "Expérience Lagune" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_53c07cd7-1ab5-4cff-8752-32dcf9dc74c8/artifacts/zfxd5ioo_IMG_3871.jpeg",
      title: { en: "Professional Instruction", es: "Instrucción Profesional", de: "Professioneller Unterricht", fr: "Instruction Professionnelle" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_53c07cd7-1ab5-4cff-8752-32dcf9dc74c8/artifacts/uog4s2ls_IMG_3872.jpeg",
      title: { en: "Dakhla Beauty", es: "Belleza de Dakhla", de: "Dakhla Schönheit", fr: "Beauté de Dakhla" }
    },
    {
      url: "https://customer-assets.emergentagent.com/job_53c07cd7-1ab5-4cff-8752-32dcf9dc74c8/artifacts/j0pnf23h_IMG_3885.jpeg",
      title: { en: "Adventure Awaits", es: "La Aventura Espera", de: "Abenteuer Wartet", fr: "L'Aventure Attend" }
    }
  ];

  const titles = {
    en: "Photo Gallery",
    es: "Galería de Fotos",
    de: "Fotogalerie",
    fr: "Galerie Photos"
  };

  const subtitles = {
    en: "Experience Dakhla through our lens",
    es: "Experimenta Dakhla a través de nuestra lente",
    de: "Erlebe Dakhla durch unsere Linse",
    fr: "Découvrez Dakhla à travers notre objectif"
  };

  return (
    <section id="gallery" className="py-24 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {titles[language]}
          </h2>
          <p className="text-xl text-gray-600">{subtitles[language]}</p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-cyan-500 mx-auto mt-4"></div>
        </div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className={`relative overflow-hidden rounded-lg cursor-pointer group ${
                index % 7 === 0 ? "md:col-span-2 md:row-span-2" : ""
              }`}
              onClick={() => setSelectedImage(image)}
            >
              <div className="aspect-square">
                <img
                  src={image.url}
                  alt={image.title[language]}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold text-lg">
                    {image.title[language]}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-6xl p-0 overflow-hidden bg-black/95 border-none">
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 z-50 p-2 bg-white/10 hover:bg-white/20 rounded-full transition-colors"
          >
            <X className="h-6 w-6 text-white" />
          </button>
          {selectedImage && (
            <div className="relative">
              <img
                src={selectedImage.url}
                alt={selectedImage.title[language]}
                className="w-full h-auto max-h-[90vh] object-contain"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <p className="text-white text-xl font-semibold text-center">
                  {selectedImage.title[language]}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Gallery;
